import { apiPatch } from '@/lib/http/client';

import type { HubspotConnectionSettings } from '../types';

// The backend exposes no GET for connection settings; an empty-body PATCH is
// a non-mutating read — the view builds `update_fields` only from keys
// present in the body, so with `{}` no `save()` occurs, and it returns the
// current `{ default_sync_direction, propagate_outbound_deletes }`.
export async function getHubspotConnectionSettings(
  orgId: number | string
): Promise<HubspotConnectionSettings> {
  return apiPatch<HubspotConnectionSettings>(
    `/api/orgs/${orgId}/hubspot/connection/`,
    {}
  );
}

export async function updateHubspotConnectionSettings(
  orgId: number | string,
  body: Partial<HubspotConnectionSettings>
): Promise<HubspotConnectionSettings> {
  return apiPatch<HubspotConnectionSettings>(
    `/api/orgs/${orgId}/hubspot/connection/`,
    body
  );
}
